import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const FormSchema = yup.object().shape({
  templateName: yup.string().required('Template Name is required'),
});

export const FormResolver = yupResolver(FormSchema);
